module.exports = __webpack_public_path__ + "static/5-88e3f2636dd4d155322e235f9be18248.jpg";